<div class="containerClass" *ngIf="loader">Loading Widgets .. </div>
<ng-template widgetHost></ng-template>